import { useMutation } from '@tanstack/react-query';
import type {
  WithdrawCryptoErrorResponse,
  WithdrawSuccessResponse,
} from '@/shared/types';
import {
  withdrawCrypto,
  type WithdrawCryptoRequestParams,
} from '@/features/withdraw-crypto';

interface UseWithdrawCryptoOptions {
  onSuccess?: (data: WithdrawSuccessResponse) => void;
  onError?: (error: WithdrawCryptoErrorResponse) => void;
}

export function useWithdrawCrypto(options?: UseWithdrawCryptoOptions) {
  const mutation = useMutation<
    WithdrawSuccessResponse,
    WithdrawCryptoErrorResponse,
    WithdrawCryptoRequestParams
  >({
    mutationFn: withdrawCrypto,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });

  return {
    ...mutation,
  };
}
